<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->

<div *ngIf="config"
     class="d-flex flex-column record-thread-item {{(config && config.klass) || ''}} {{dynamicClass}}">
    <div class="record-thread-item-header flex-grow-1">

        <ng-container *ngIf="config.metadata && config.metadata.headerLayout">

            <scrm-record-flexbox [config]="buildConfig(config.metadata.headerLayout)"></scrm-record-flexbox>
        </ng-container>

    </div>
    <div #body
         [class.collapsed]="collapsible && collapsed"
         [class.expanded]="collapsible && !collapsed"
         class="record-thread-item-body flex-grow-1 {{getBodyClass()}}">

        <ng-container *ngIf="config.metadata && config.metadata.bodyLayout">
            <scrm-record-flexbox [config]="buildConfig(config.metadata.bodyLayout)"></scrm-record-flexbox>
        </ng-container>

        <div *ngIf="collapsible && collapsed" class="fadeout"></div>

    </div>

    <div *ngIf="collapsible" class="record-thread-item-collapse d-flex justify-content-center flex-grow-1">
        <scrm-button [config]="getCollapseButton()"></scrm-button>
    </div>
</div>
